export default __webpack_public_path__ + "static/media/fumigation-2.50157db8.svg";